// Sugalarm — windowed glucose stats (cycle 142).
//
// The TIR% / average / low-EPISODES triple shown under the Now-screen
// charts. Extracted from the cycle-116 inline NowScreen computation so
// the portrait stats strip, the bare-state strip, the trend overlay
// footer, and the landscape chart strip all consume ONE definition —
// they can never disagree.
//
// "Lows" counts low EPISODES, not low readings: a consecutive run of
// sub-`target_low` readings counts once (cycle 116 semantics).

import type { Reading, Thresholds } from "./types";

export interface GlucoseWindowStats {
  /** Percent of readings inside [target_low, target_high], rounded;
   *  null when the window holds no readings. */
  tir: number | null;
  /** Mean sgv (mg/dL), rounded; null when the window holds no readings. */
  avg: number | null;
  /** Count of consecutive sub-target_low runs (each run counts once). */
  lows: number;
}

export function glucoseWindowStats(
  readings: readonly Reading[],
  thresholds: Thresholds,
): GlucoseWindowStats {
  const lo = thresholds.target_low;
  const hi = thresholds.target_high;
  const n = readings.length;
  if (n === 0) return { tir: null, avg: null, lows: 0 };
  let inRange = 0;
  let sum = 0;
  let lows = 0;
  let inLowRun = false;
  for (const r of readings) {
    sum += r.sgv;
    if (r.sgv >= lo && r.sgv <= hi) inRange += 1;
    if (r.sgv < lo) {
      if (!inLowRun) {
        lows += 1;
        inLowRun = true;
      }
    } else {
      inLowRun = false;
    }
  }
  return {
    tir: Math.round((inRange / n) * 100),
    avg: Math.round(sum / n),
    lows,
  };
}
